var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          model: {
            value: _vm.show_report,
            callback: function($$v) {
              _vm.show_report = $$v
            },
            expression: "show_report"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_report = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.title) + "\n\t\t\t\t")
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c(
                    "q-list",
                    { attrs: { separator: "", highlight: "", link: "" } },
                    _vm._l(_vm.questions, function(question, index) {
                      return _c(
                        "q-item",
                        {
                          key: index,
                          nativeOn: {
                            click: function($event) {
                              return _vm.showQuestion(question)
                            }
                          }
                        },
                        [
                          _c("q-item-main", {
                            attrs: {
                              label: question.title,
                              "label-lines": "1",
                              sublabel:
                                _vm.$t("user_answers") +
                                ": " +
                                question.qty_user_answered,
                              "sublabel-lines": "1"
                            }
                          })
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("user-answers", {
        attrs: {
          question: _vm.question,
          show_question: _vm.show_question,
          title: _vm.title,
          id: _vm.id
        },
        on: { hide_user_answers: _vm.hideUserAnswers }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }